import { useState } from "react";

import NotificationsSidebar from "./NotificationsSidebar";
import NotificationsBody from "./NotificationsBody";

import "./styles.scss";

const NOTIFICATION_ITEMS = ["Mail", "Syslog", "Prtg", "Social"];

const Notifications = () => {
  const [selectedNotification, setSelectedNotification] = useState(NOTIFICATION_ITEMS[0]);

  const selectItemHandler = (_, notification) => {
    setSelectedNotification(notification);
  };

  return (
    <div className="notifications-container">
      <div className="notifications-container__header">
        <h1>Notification Settings</h1>
        <p>You can configure and view the current settings of any notification</p>
      </div>
      <div className="notifications">
        <NotificationsSidebar
          items={NOTIFICATION_ITEMS}
          onItemSelect={selectItemHandler}
          selectedNotification={selectedNotification}
        />
        <NotificationsBody selectedNotification={selectedNotification} />
      </div>
    </div>
  );
};

export default Notifications;
